function urlsEquivalent(a, b) {
  try {
    const ua = new URL(a, window.location.href);
    const ub = new URL(b, window.location.href);
    const normalize = (u) => {
      // compare origin + pathname (no trailing slashes) + search; ignore hash
      const trimmedPath = u.pathname.replace(/\/+$/, '') || '/';
      return `${u.origin}${trimmedPath}${u.search}`;
    };
    return normalize(ua) === normalize(ub);
  } catch {
    return false;
  }
}

export function initLangSelect(selectEl) {
  if (!selectEl || selectEl.dataset.langSelectInited === 'true') return;

  const onChange = (e) => {
    const select = e.currentTarget;
    const selected =
      select.selectedOptions?.[0] ?? select.options[select.selectedIndex];

    const url = selected?.dataset?.url || selected?.getAttribute('data-url');
    if (!url) return;

    // Do not redirect if the selected option already points to the current page
    if (!urlsEquivalent(url, window.location.href)) {
      window.location.assign(url);
    }
  };

  selectEl.addEventListener('change', onChange);
  selectEl.dataset.langSelectInited = 'true';
}

export function initAllLangSelects(root = document) {
  const selects = root.querySelectorAll('select.js-lang-select');
  selects.forEach(initLangSelect);
}
